/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Summarywebcountedsince3Inputs */

const en_summarywebcountedsince3 = /** @type {(inputs: Summarywebcountedsince3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Website views are counted from ${i?.date}; earlier ones are not included.`)
};

const de_summarywebcountedsince3 = /** @type {(inputs: Summarywebcountedsince3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aufrufe auf der Website zählen wir ab ${i?.date}, frühere sind nicht enthalten.`)
};

/**
* | output |
* | --- |
* | "Website views are counted from {date}; earlier ones are not included." |
*
* @param {Summarywebcountedsince3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarywebcountedsince3 = /** @type {((inputs: Summarywebcountedsince3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarywebcountedsince3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarywebcountedsince3(inputs)
	return de_summarywebcountedsince3(inputs)
});
export { summarywebcountedsince3 as "summaryWebCountedSince" }